import React, { useState } from 'react';
import { db } from "../firebase.js";

import { collection, addDoc, serverTimestamp} from "firebase/firestore";

const MatrimonialForm = () => {
  const [formData, setFormData] = useState({
    name: '',             // Name
    ling: '',             // Gender
    jaati: '',            // Caste
    varg: '',             // Category
    mobile: '',           // Mobile Number
    dob: '',              // Date of Birth
    gaon: '',             // Village
    tahsil: '',           // Tehsil
    jila: '',             // District
    rajya: '',            // State
    shikshit: '',         // Education Level
    fatherName: '',       // Father's Name
    height: '',           // Height
    weight: '',             // Weight
    skin: '',             // Skin Tone
    shadishuda: '',       // Marital Status
    rojgar: '',           // Employment Status
    vartman: '',          // Current Situation
    hobbies: '',          // Hobbies
    yogyata: '',          // Qualifications
    occupation: '',       //occupation
    income: '',           // Income
    apekshitUmra: '',     // Expected Age
    kshetra: '',          // Area
    apekshitSahyog: ''    // Expected Cooperation
  });
  

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? value : event.target.value, // Handle radio input types
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await addDoc(collection(db, 'rotiBetiData'), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      alert('व्यक्ति सफलतापूर्वक जोड़ा गया!');
      setFormData({
        name: '',             // Name
        ling: '',             // Gender
        jaati: '',            // Caste
        varg: '',             // Category
        mobile: '',           // Mobile Number
        dob: '',              // Date of Birth
        gaon: '',             // Village
        tahsil: '',           // Tehsil
        jila: '',             // District
        rajya: '',            // State
        shikshit: '',         // Education Level
        fatherName: '',       // Father's Name
        height: '',           // Height
        weight: '',             // Weight
        skin: '',             // Skin Tone
        shadishuda: '',       // Marital Status
        rojgar: '',           // Employment Status
        vartman: '',          // Current Situation
        hobbies: '',          // Hobbies
        yogyata: '',          // Qualifications
        occupation: '',       //occupation
        income: '',           // Income
        apekshitUmra: '',     // Expected Age
        kshetra: '',          // Area
        apekshitSahyog: ''    // Expected Cooperation
      });
    } catch (error) {
      console.error('Error saving data:', error);
      // Handle errors appropriately (e.g., display an error message)
    }
  };
  return (
    <div className="min-h-screen p-6 bg-[#f0f4de]">
      <h1 className="text-7xl font-extrabold text-[#991311] mb-4 text-center sm:text-left">
        रोटी बेटी का रिश्ता बनाने हेतु जुड़ें
      </h1>
      <h2 className="text-3xl font-semibold mb-2 text-center sm:text-left">
        अभियान को सार्थक बनाने हेतु लोगों को प्रेरित करें और जोडें <br />
        जात पात के सामाजिक भेदभाव को समाप्त करने हेतु रोटी बेटी का रिश्ता जोड़ना होगा| ऐसे सामाजिक अभियान में भाग लेने हेतु प्रतिभागियों का संक्षिप्त विवरण उपलब्ध कराएं| नए उन्नत भारत का निर्माण करने में अपनी भूमिका सुनिश्चित करें|
      </h2>
      <h2 className="text-3xl font-semibold text-[#991311] mb-2 text-center sm:text-left">
        प्रत्येक सफल संयोग होने पर 
        परिचय कर्ता को 25 हजार रुपये की सहयोग राशी प्रदान की जायेगी
      </h2>
      <form className="bg-white border border-gray-300 flex flex-col sm:flex-row md:flex-row" onSubmit={handleSubmit}>
        {/* Left Section */}
        <div className="w-full sm:w-1/2 p-4 border-b sm:border-b-0 sm:border-r border-gray-300">
          <div className="space-y-3">
            <div className="flex flex-col sm:flex-row gap-2 items-center">
              <div>
                <label>शादी करने के इक्षुक प्रत्याशी का नाम</label>
                <input
                  type="text"
                  placeholder="Ram Thakur"
                  className="border px-2 py-1 placeholder-gray-500"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-2">
                <label>लिंग </label>
                <input
                  type="text"
                  placeholder="Male/Female"
                  className="border px-2 py-1 placeholder-gray-500"
                  name="ling"
                  value={formData.ling}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <label>जाति</label>
              <input
                type="text"
                placeholder="Rajas"
                className="border px-2 py-1 placeholder-gray-500"
                name="jaati"
                value={formData.jaati}
                onChange={handleChange}
                required
              />
              <label>वर्ग</label>
              <input
                  type="text"
                  placeholder="ST/SC/OBC/GEN"
                  className="border px-2 py-1 placeholder-gray-500"
                  name="varg"
                  value={formData.varg}
                  onChange={handleChange}
                  required
                />
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <label>मोबाईल नम्बर</label>
              <input
                type="text"
                placeholder="+91 555 555-1234"
                className="border px-2 py-1 placeholder-gray-500"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
              <label>Date of Birth</label>
              <input
                type="date"
                placeholder="12.05.1992"
                className="border px-2 py-1 placeholder-gray-500"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
              <div>
                <label>गाँव</label>
                <input
                  type="text"
                  placeholder="Rajas"
                  className="border px-2 py-1 w-full placeholder-gray-500"
                  name="gaon"
                  value={formData.gaon}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label>तहसील</label>
                <input
                  type="text"
                  placeholder="Udaipur"
                  className="border px-2 py-1 w-full placeholder-gray-500"
                  name="tahsil"
                  value={formData.tahsil}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label>जिला</label>
                <input
                  type="text"
                  placeholder="Kanker"
                  className="border px-2 py-1 w-full placeholder-gray-500"
                  name="jila"
                  value={formData.jila}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label>राज्य</label>
                <input
                  type="text"
                  placeholder="Chhattisgarh"
                  className="border px-2 py-1 w-full placeholder-gray-500"
                  name="rajya"
                  value={formData.rajya}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div>
              <label>शैक्षिक योग्यता  शिक्षित / अशिक्षित</label>
              <input
                type="text"
                placeholder="10 / 12 / GRADUATE / POSTGRADUATE / PHD"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="shikshit"
                value={formData.shikshit}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>पिता का नाम</label>
              <input
                type="text"
                placeholder="Ramdeen Thakur"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="fatherName"
                  value={formData.fatherName}
                  onChange={handleChange}
                required
              />
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div>
                <label>लम्बाई - HEIGHT (IN CM)</label>
                <input
                  type="text"
                  placeholder="178"
                  className="border px-2 py-1 placeholder-gray-500"
                  name="height"
                  value={formData.height}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <label>वजन - WEIGHT (IN KG)</label>
                <input
                  type="text"
                  placeholder="62"
                  className="border px-2 py-1 placeholder-gray-500"
                  name="weight"
                  value={formData.weight}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div>
              <label> रंग - SKIN TONE </label>
              <input
                type="text"
                placeholder="गोरा / गेंहुआ / डार्क "
                className="border px-2 py-1 placeholder-gray-500"
                name="skin"
                value={formData.skin}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>कुंवारापन या शादी शुदा</label>
              <input
                type="text"
                placeholder="Horoscope"
                className="border px-2 py-1 placeholder-gray-500"
                name="shadishuda"
                value={formData.shadishuda}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>रोजगार</label>
              <input
                type="text"
                placeholder="Service/ Private / Government Business / Manufacturer / Consultant"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="rojgar"
                value={formData.rojgar}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>वर्तमान आय सालाना -  INCOME </label>
              <input
                type="text"
                placeholder="10,00,000"
                className="border px-2 py-1 placeholder-gray-500"
                name="vartman"
                  value={formData.vartman}
                  onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>HOBBIES</label>
              <input
                type="text"
                placeholder="TRAVELING / BOOK READING / KITCHEN / ART AND CROFT / FARMING / TEACHING / FASHION DESIGNER"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="hobbies"
                value={formData.hobbies}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          {/* Button at the bottom-left */}
          <div className="mt-6">
            <button className="bg-[#B50301] text-white px-6 py-2 rounded-full w-full sm:w-auto">
              जमा करें/ सबमिट करें
            </button>
          </div>
        </div>

        {/* Right Section */}
        <div className="w-full sm:w-1/2 p-4">
          <h3 className="text-lg font-semibold underline mb-4">संयोग कैसा अपेक्षित करते हैं</h3>
          <div className="space-y-3">
            <div>
              <label>अपेक्षित शैक्षिक योग्यता</label>
              <input
                type="text"
                placeholder="10 / 12 / GRADUATE / POSTGRADUATE / PHD"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="yogyata"
                value={formData.yogyata}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <input
                type="text"
                placeholder="सेवा/  निजी / सरकारी/व्यवसाय / निर्माता / सलाहकार"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>अपेक्षित आय सालाना -  INCOME </label>
              <input
                type="text"
                placeholder="10,00,000"
                className="border px-2 py-1 placeholder-gray-500"
                name="income"
                value={formData.income}
                onChange={handleChange}
                
              />
            </div>

            <div>
              <label>अपेक्षित उम्र </label>
              <input
                type="number"
                placeholder="32"
                className="border px-2 py-1 placeholder-gray-500"
                name="apekshitumra"
                value={formData.apekshitUmra}
                onChange={handleChange}
                
              />
            </div>

            <div>
              <label>अपेक्षित रिहायशी क्षेत्र  </label>
              <input
                type="text"
                placeholder="शहरी / अर्ध शहरी / ग्रामीण क्षेत्र"
                className="border px-2 py-1 w-full placeholder-gray-500"
                name="kshetra"
                value={formData.kshetra}
                onChange={handleChange}
                required
              />
            </div>

            <div>
              <label>अपेक्षित संयोग</label>
              <input
                type="text"
                placeholder="500 words"
                className="border px-2 py-1 placeholder-gray-500"
                name="apekshitsahyog"
                value={formData.apekshitSahyog}
                onChange={handleChange}
              
              />
            </div>

            <div>
              <label>संक्षिप्त अपेक्षाएं</label>
              <div className="space-y-2">
                <div>शर्तों के सहमती हेतु चेक मार्क बॉक्स </div>
                <div>
  <label>
    <input type="checkbox" name="caste-discrimination" />
    1. जाती पाती के भेदभाव को नहीं मानता / नहीं मानती हूँ
  </label>
</div>
<div>
  <label>
    <input type="checkbox" name="social-harmony" />
    2. सामाजिक समरसता हेतु रोटी बेटी का सम्बन्ध बनाना चाहते हैं
  </label>
</div>
<div>
  <label>
    <input type="checkbox" name="indian-culture" />
    3. भारतीय संस्कृति, परम्पराएँ और रीती रिवाज को निभायेगें
  </label>
</div>
<div>
  <label>
    <input type="checkbox" name="family-system" />
    4. सामाजिक और परिवार व्यवस्था को मजबूत बनायेगें
  </label>
</div>

              </div>
            </div>

            <div>
              <label>दस्तावेज उपलब्ध / अपलोड करें जो लागु हो</label>
              <div>
                <div>1. DOB प्रूफ</div>
                <div>2. शैक्षिक योग्यता</div>
                <div>3. Marriage</div>
                <div>4. सर्विस / ब्यापार / आय</div>
              </div>
            </div>

            <div>
              <label>परिचय कर्ता का मोबाईल नम्बर</label>
              <input
                type="text"
                placeholder="+91 555 555-1234"
                className="border px-2 py-1 placeholder-gray-500"
                required
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default MatrimonialForm;
